import { SmsFailed } from "@mui/icons-material";
import styles from "./styles.module.css";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";



const BackBoxNotification = styled.div`
  position: absolute;
  background: rgba(145, 145, 145, 0.2);
  backdrop-filter: blur(10px);
  display: ${({ $handleOpenNotifi }) => ($handleOpenNotifi ? "flex" : "none")};
  flex-direction: column;
  align-items: center;
  padding: 0.7rem;
  top: 4.5rem;
  right: 0.5rem;
  gap: 1rem;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  max-height: 21.5rem;
  overflow-y: scroll;
`;

const ModuleNotification = ({ type, path, title, text, date, status, close }) => {

  const navigate = useNavigate();

  let color = "";
  switch (type) {
    case "ALERT":
      color = "#FF0000";
      break;

    case "WARNING":
      color = "#ffc400";
      break;

    case "SUCESS":
      color = "#13990f";
      break;

    default:
      color = "#0275FF";
      break;
  }

  let opacity = "";
  let border = 'none';

  switch (status) {
    case "LIDA":
      opacity = "0.8";
      break;

    default:
      opacity = "1";
      border = '1px solid #18316e'
      break;
  }

  return (
    <div
      onClick={() => {
        navigate(path)
        close()
      }}
      className={styles.notificacao__ancora}
      style={{ opacity: opacity }}
    >
      <div className={styles.notificacao__module} style={{ border }}>
        <SmsFailed sx={{ color: color, fontSize: "3rem" }} />
        <div className={styles.notifications__texts}>
          <div className={styles.line_one}>
            <h1>{title}</h1>
            <span className={styles.notificacao__date}>{date}</span>
          </div>
          <span>{text}</span>
        </div>
      </div>
    </div>
  );
};

const Notificacao = ({ HandleOpen, dataNotifications, handleCloseNotifications }) => {

  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (HandleOpen && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        handleCloseNotifications();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef, handleCloseNotifications]);

  return (
    <>
      <BackBoxNotification $handleOpenNotifi={HandleOpen} ref={wrapperRef}>
        {dataNotifications ? (dataNotifications.map((notification, index) => (
          <ModuleNotification
            key={index}
            type={notification.tipo}
            path={notification.path}
            title={notification.titulo}
            text={notification.texto}
            date={notification.dthora}
            status={notification.status}
            close={handleCloseNotifications}
          />
        ))) : ""}
      </BackBoxNotification>
    </>
  );
};

export default Notificacao;
